<table class="table">
  <tbody>
    <tr ng-repeat-start="(key, itens) in afericoes">
      <td colspan="2">
        <b><i class="icon-fulltrator"></i> {{itens[0].maquina.descricao}}</b>
      </td>
    </tr>
    <tr ng-repeat-end ng-repeat="afericao in itens track by $index"
          ng-mouseleave="resetAnimationMarker(afericao.marker.marker, afericao.marker.leafletMarker)"
          ng-mouseover="setAnimationMarker(afericao.marker.marker, afericao.marker.leafletMarker)"
          ng-click="openInfoWindow(afericao.marker.marker, afericao.marker.leafletMarker)"
          ng-class="{'activate-line': afericao.marker.leafletMarker.isPopupOpen()}"
          class="pointer">
      <td ng-if="afericao.tipo != 'aplicacao_afericao'">Ponto {{$index + 1}}{{afericao.marker.marker._id}}</td>
      <td ng-if="afericao.tipo == 'aplicacao_afericao'">Amostra {{$index + 1}}{{afericao.marker.marker._id}}</td>
      <td ng-if="afericao.tipo == 'colheita_afericao'">{{afericao.perda_kg | number:1}}kg/ha {{afericao.percentual_perda ? (afericao.percentual_perda|number:2)+ '%' : ''}}</td>
      <td ng-if="afericao.subtipo.id === 'semente' && afericao.tipoMedida.id != 'peso'">{{afericao.densidade | number:0}} sementes/ha</td>
      <td ng-if="afericao.subtipo.id === 'semente' && afericao.tipoMedida.id == 'peso'">{{afericao.densidade | number:2}} kg/ha (Semente)</td>
      <td ng-if="afericao.subtipo.id === 'gema' ">{{afericao.totais_cana.total_gemas | number:0}} Gemas</td>
      <td ng-if="afericao.subtipo.id === 'adubo'">{{afericao.densidade | number:1}} kg/ha (Adubo)</td>
      <td ng-if="afericao.velocidade && afericao.subtipo.id !== 'gema'">{{afericao.velocidade}} km/h</td>
      <td ng-if="afericao.total_gasto && afericao.subtipo.id !== 'gema'">{{afericao.total_gasto | number:2}} mL</td>
    </tr>
  </tbody>
</table>
